import { Common, Accessors } from "../../helper";

const SuperAdminColumns = [
  {
    Header: "",
    accessor: Accessors.Action,
  },
  {
    Header: Common.Name,
    accessor: Accessors.Name,
  },
  {
    Header: Common.ContactName,
    accessor: Accessors.ContactName,
  },
  {
    Header: Common.Active,
    accessor: Accessors.Active,
  },
  {
    Header: Common.SchoolEmail,
    accessor: Accessors.Email,
  },
  {
    Header: Common.SchoolUsers,
    accessor: Accessors.UserCount,
  },
  {
    Header: Common.Address,
    accessor: Accessors.Addresss,
  },
];

export { SuperAdminColumns };
